<template>
  <teleport to="body">
    <base-modal
      size="md"
      :show="show"
      has-close-btn
      :heading="headingText"
      :warning="warning"
      :danger="danger"
      :auto-focus-modal="false"
      @close:modal="() => $emit('close:modal')"
    >
      <template v-if="confirmText || reason" #default>
        <p
          v-if="confirmText"
          class="tw-whitespace-pre-line"
          :class="{ 'tw-mb-6': reason }"
        >
          {{ confirmText }}
        </p>

        <base-input
          v-if="reason"
          test-id="delete-reason"
          focus
          :label="$t('archive_reason')"
          :model-value="reasonInput"
          :warning="warning"
          :danger="danger"
          :errors="validationErrors.reason"
          :required="formValidation.reason.required"
          :min="formValidation.reason.min"
          :max="formValidation.reason.max"
          :show-count="formValidation.reason.min > 0"
          @input="(input) => (reasonInput = input)"
          @enter="confirmDelete"
        />
      </template>

      <template #footer>
        <base-button
          :focus="true"
          :success="success"
          :info="info"
          :warning="warning"
          :danger="danger"
          :status="status"
          full-width-at="sm"
          icon="exclamation-triangle"
          @click="confirmDelete"
          >{{ $t(buttonText) }}
        </base-button>
      </template>
    </base-modal>
  </teleport>
</template>

<script>
import { statusConfig as formValidation } from '@config/validation.js'
import { useValidate } from '@composables'
import { toRefs, ref } from 'vue'

export default {
  props: {
    headingText: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Boolean,
      default: false,
    },
    warning: {
      type: Boolean,
      default: false,
    },
    danger: {
      type: Boolean,
      default: false,
    },
    focus: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'delete',
    },
    status: {
      type: String,
      default: null,
    },
    reason: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close:modal', 'delete'],
  setup(props, { emit }) {
    const { reason } = toRefs(props)
    const reasonInput = ref('')

    const validationErrors = ref({
      reason: [],
    })

    function confirmDelete() {
      const validator = useValidate({
        reason: formValidation.validation.reason,
      })
      validationErrors.value = validator.errors

      if (!reason.value) {
        emit('delete')
        return
      }

      validator.validate('reason', reasonInput.value)
      if (!validator.hasErrors()) emit('delete', reasonInput.value)
    }

    return {
      validationErrors,
      formValidation,
      confirmDelete,
      reasonInput,
    }
  },
}
</script>
